import moment from 'moment';

import { localeStore } from 'stores';

import { ParrentModel } from './parrentModel';

class Team extends ParrentModel<TeamType> {}

export { Team };
